import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {ActivityParticipantAttendanceStatus} from 'nutshell-graphql-types';

import {colors} from '../colors/colors';
import {CheckRegularIcon} from '../icon/svg/check-regular-icon';
import {CloseLightRegularIcon} from '../icon/svg/close-light-regular-icon';

import styles from './avatar-attendance-badge.module.css';

type Props = {
    attendanceStatus: ActivityParticipantAttendanceStatus;
};

export function AvatarAttendanceBadge(props: Props): React.ReactElement | null {
    if (props.attendanceStatus === 'PENDING') {
        return null;
    }

    let variantClass: string;
    let icon: React.ReactNode;

    switch (props.attendanceStatus) {
        case 'ATTENDING':
            variantClass = styles['attendance-badge--attending'];
            icon = <CheckRegularIcon size={11} fill={colors.success} />;
            break;
        case 'ABSENT':
            variantClass = styles['attendance-badge--absent'];
            icon = <CloseLightRegularIcon size={11} fill={colors.alert} />;
            break;
        case 'MAYBE':
            variantClass = styles['attendance-badge--maybe'];
            icon = (
                <Body isBold={true} size='mini' color='orange-attention'>
                    ?
                </Body>
            );
            break;
        default:
            return null;
    }

    return <div className={variantClass}>{icon}</div>;
}
